import { render, staticRenderFns } from "./SettingTab.vue?vue&type=template&id=21722ca8&scoped=true"
import script from "./SettingTab.vue?vue&type=script&lang=js"
export * from "./SettingTab.vue?vue&type=script&lang=js"
import style0 from "./SettingTab.vue?vue&type=style&index=0&id=21722ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21722ca8",
  null
  
)

export default component.exports